module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<tr v-bind:id='rowId'>\n  <td>{{row.procurement_subject}}</td>\n  <td>{{row.procurement_type}}</td>\n  <td>{{row.procurement_invite_date}}</td>\n  <td>{{row.decision_announcement_date}}</td>\n  <td>{{row.total_amount_without_vat}}</td>\n  <td>{{row.applicable_amount}}</td>\n  <td>{{row.agreement_party_name}}</td>\n  <td>{{row.agreement_sign_date}}</td>\n  <td>{{row.agreement_number}}</td>\n  <td>{{row.procurement_agreement_state}}</td>\n  <td>{{row.translated_agreement_state}}</td>\n  <td>{{row.agreement_end_date}}</td>\n  <td>{{row.green_procurement}}</td>\n  <td>\n    <div class='form-group'>\n      <textarea class='form-control' cols='" + ($e($c(30))) + "' name='client_notes' v-model='row.client_notes'></textarea>\n    </div>\n  </td>\n</tr>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
